export interface NotificationItem {
    connectUserId: string;
    createdDate: number;
    customerName: string;
    deleteAfter: number;
    entityName: string;
    entityId: string;
    entityType: string;
    exportType?: string;
    importType?: string;
    notificationType: string;
    notificationId: string;
    url: string
}


export const NOTIFICATION_EXPORT_KEYS = ['userList',
    'companyList',
    'clientCompanyList',
    'companyServiceAccess',
    'clientCompanyServiceAccess',
    'customerServiceAccess',
    'changeLog',
    'companyGroupServiceAccess',
    'userRolesForCustomer',
    'userGroupRoles',
    'userGroupsForCustomer'];

export const NOTIFICATION_IMPORT_KEYS = [
    'importUsers'
]

export const NOTIFICATION_COPY_USER_ACCESS = 'copyUserAccess';

export const NOTIFICATION_INCLUDE_ALL_MEMBERS = [
    'addAllPossibleMembersUserToUserGroup', 
    'addAllPossibleMembersCompanyToCompanyGroup',
    'addAllPossibleMembersClientCompanyToCompanyGroup'
];
